/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Overlay} from "@angular/cdk/overlay";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {SessionService} from "../../platform/base/services/session.service";
import {Guests2Service} from "../guests2/guests2.service";

import {Callback, IErrorObject} from "../../../../types/platform/universe";
import {SessionableComponent} from "../../platform/base/components/sessionable.component";

import {MessageDialogComponent} from "../base/components/message-dialog/message-dialog.component";
import {TranslateService} from "@ngx-translate/core";

@Component({
	selector: 'app-profile2',
	templateUrl: './profile2.component.html',
	styleUrls: ['./profile2.component.css']
})

export class Profile2Component extends SessionableComponent implements OnInit {

	public type: string;
	public nickname: string;
	private user_id: string = "";

	public params: any = {};

	/**
	 *
	 * @param session
	 * @param overlay
	 * @param accountService
	 * @param matDialog
	 * @param router
	 * @param route
	 * @param translate
	 */
	constructor(
		protected session: SessionService,
		protected accountService: Guests2Service,
		protected matDialog: MatDialog,
		protected router: Router,
		protected route: ActivatedRoute,
		protected overlay: Overlay,
		public translate: TranslateService
	) {
		super(session);
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error:IErrorObject) => {}): void {
		if (error) {
			if (error.code === 1) {
				this.router.navigate(['/']);
			} else {
				const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: {title: "Error.", message: error.message, tag: error.tag}},
					disableClose: true,
				});

				dialog.afterClosed().subscribe((result: any): void => {
					callback(result);
				});
			}
		}
	}

	/**
	 * アカウント参照
	 * @param user_id
	 * @param callback
	 */
	private getUser(user_id: any, callback: Callback<object>): void {
		this.Progress(true);
		this.accountService.get_user(user_id, (error: IErrorObject, result: object): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
			this.Progress(false);
		});
	}

	/**
	 * アカウント参照
	 * @param callback
	 */
	private getSelf(callback: Callback<object>): void {
		this.Progress(true);
		this.accountService.get_user(null, (error: IErrorObject, result: object): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
			this.Progress(false);
		});
	}

	// http://localhost:3000/profile?c=24718d89e2&s=6071f9e969&i=6172122c651b44549b390add
	public ngOnInit(): void {
		this.getSession((error: IErrorObject, session: any): void => {
			if (!error) {
				this.route.queryParams.subscribe((params) => {
					this.params = params;
					if (this.params.i) {
						this.user_id = decodeURIComponent(this.params.i);
					}
					//	const user_id = "5fbb62cbbb667c59ad0c694b";
					this.getUser(this.user_id, (error: IErrorObject, content: any): void => {
						if (!error) {
							this.draw(content);
						} else {
							this.errorDialog(error);
						}
					});
				});
			} else {
				this.errorDialog(error);
			}
		});
	}

	/**
	 * @returns none
	 */
	protected draw(content: any): void {
		this.type = content.type;
		this.nickname = content.nickname;
	}
}
